var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "video-container" }, [_c('div', { staticClass: "video", style: _vm.videoStyle }, [_c('video-player', { attrs: { "video": _vm.url, "cover": _vm.cover, "videoStyle": _vm.innerVideoStyle, "type": "list" } })], 1), _vm._v(" "), _c('file-meta', _vm._b({ attrs: { "customStyle": _vm.fileMetaStyle } }, 'file-meta', _vm.fileMeta, false))], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };